(function (app) {

    app.provider("marketingTrackerEventGroupApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.get = function (eventGroupId) {
                            return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId);
                        };

                        service.getEventGroups = function () {
                            return marketingTrackerApiGateway.getArray("/EventGroups/");
                        };
                        /*
                        service.getFigAuthUserEventGroupsByDate = function (figAuthUserId, eventTypes, startDate, endDate, nextPageToken) {
                            var url = "/Users/FigAuth/" + figAuthUserId + "/EventGroups/ByDate";
                            return marketingTrackerApiGateway.get(url,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate,
                                        eventTypes: eventTypes,
                                        nextPageToken: nextPageToken
                                    }
                                });
                        };
                        */
                        service.getUserEventGroupsByDate = function (eventTypes, startDate, endDate, nextPageToken) {
                            var url = "/Users/EventGroups/ByDate";
                            return marketingTrackerApiGateway.get(url,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate,
                                        eventTypes: eventTypes,
                                        nextPageToken: nextPageToken
                                    }
                                });
                        };

                        /*
                        service.downloadFigAuthUserEventGroupsByDate = function (figAuthUserId, eventTypes, startDate, endDate) {
                            var url = "/Users/FigAuth/" + figAuthUserId + "/EventGroups/ByDate/Download";
                            return marketingTrackerApiGateway.getFile(url,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate,
                                        eventTypes: eventTypes
                                    }
                                });
                        };
                        */
                        service.downloadUserEventGroupsByDate = function (eventTypes, startDate, endDate) {
                            var url = "/Users/EventGroups/ByDate/Download";
                            return marketingTrackerApiGateway.getFile(url,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate,
                                        eventTypes: eventTypes
                                    }
                                });
                        };

                        service.getEvent = function (eventGroupId, eventId) {
                            return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/Events/" + eventId);
                        };

                        service.getUserEventGroups = function (userId) {
                            return marketingTrackerApiGateway.getArray("/Users/" + userId + "/EventGroups");
                        };

                        service.getEvents = function (eventGroupId) {
                            return marketingTrackerApiGateway.getArray("/EventGroups/" + eventGroupId + "/Events");
                        };

                        service.update = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId, eventGroup);
                        };

                        service.updateAppointmentsSet = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/AppointmentsSet", eventGroup);
                        };

                        service.updateAppointmentsKept = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/AppointmentsKept", eventGroup);
                        };

                        service.updateAppointmentsClosed = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/AppointmentsClosed", eventGroup);
                        };

                        service.updateReservations = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/Reservations", eventGroup);
                        };

                        service.updateUnitsAttended = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/UnitsAttended", eventGroup);
                        };

                        service.updateAttendees = function (eventGroupId, eventGroup) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/Attendees", eventGroup);
                        };

                        service.updateEvent = function (eventGroupId, eventId, event) {
                            return marketingTrackerApiGateway.put("/EventGroups/" + eventGroupId + "/Events/" + eventId, event);
                        };

                        service.create = function (eventGroup) {
                            return marketingTrackerApiGateway.post("/EventGroups", eventGroup);
                        };

                        service.addEvent = function (eventGroupId, event) {
                            return marketingTrackerApiGateway.post("/EventGroups/" + eventGroupId + "/Events", event);
                        };

                        service.delete = function (eventGroupId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId);
                        };

                        service.deleteEvent = function (eventGroupId, eventId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId + "/Events/" + eventId);
                        };

                        service.postEventResponders = function (eventGroupId, eventId, file) {
                            return marketingTrackerApiGateway.postFile("/EventGroups/" + eventGroupId + "/Events/" + eventId + "/Responders", file);
                        };

                        service.getEventResponders = function (eventGroupId, eventId) {
                            return marketingTrackerApiGateway.getArray("/EventGroups/" + eventGroupId + "/Events/" + eventId + "/Responders");
                        };

                        service.deleteEventResponders = function (eventGroupId, eventId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId + "/Events/" + eventId + "/Responders");
                        };

                        service.postEventRespondersFromRmeApi = function (eventGroupId, eventId, rmeCampaignId, startDate, endDate) {
                            return marketingTrackerApiGateway.post("/EventGroups/" + eventGroupId + "/Events/" + eventId + "/Responders/RmeCampaign/" + rmeCampaignId + "?startDate=" + startDate + " +&endDate=" + endDate,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                });
                        };

                        service.postEventRespondersFromRmeApiV2 = function (eventGroupId, rmeCampaignId, rmeCampaignEventId, startDate, endDate) {
                            return marketingTrackerApiGateway.post("/EventGroups/" + eventGroupId + "/Responders/RmeCampaign/" + rmeCampaignId + "/RmeEvent/" + rmeCampaignEventId + "?startDate=" + startDate + " +&endDate=" + endDate,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                });
                        };

                        service.refreshEventRespondersFromRmeApiV2 = function (eventGroupId, startDate, endDate) {
                            return marketingTrackerApiGateway.post("/EventGroups/" + eventGroupId + "/Responders/RmeCampaign/Refresh?startDate=" + startDate + "+&endDate=" + endDate,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                });
                        };

                        service.getEventGroupRmeCampaign = function (eventGroupId) {
                            return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/RmeCampaign");
                        };

                        service.deleteEventGroupRmeCampaign = function (eventGroupId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId + "/RmeCampaign");
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line